import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Checkbox, Typography } from '@material-ui/core';
import Section from '../Section';
import { loadTexts } from '../../../../config/texts';

import { updateSurveySkippable } from '../../actions';
import { fetchUser } from '../../../auth/actions';
const TEXT_KEY = "organization";

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  }
});

class SkipSurvey extends React.Component {
  state = {
    checked: get(this, 'props.organization.surveySkippable') || false,
    texts: loadTexts(TEXT_KEY, this.props.locale)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedOrganization !== this.props.selectedOrganization) {
      this.setState({
        checked: get(this, 'props.organization.surveySkippable') || false,
      });
    }
  }

  _onCancel = () => {
    this.setState({
      checked: get(this, 'props.organization.surveySkippable') || false,
    });
  };

  _onSave = async () => {
    await this.props.updateSurveySkippable({
      organization: this.props.selectedOrganization,
      skippable: this.state.checked,
    })
    this.props.fetchUser();
  };

  _onChange = event => {
    this.setState({ checked: event.target.checked });
  };

  render() {
    const { checked, texts } = this.state;
    const { classes, organization } = this.props;
    return (
      <Section
        onCancel={this._onCancel}
        onSave={this._onSave}
        saveDisabled={checked === (organization.surveySkippable || false)}
        cancelDisabled={false}
      >
        <div className={classes.container}>
          <Checkbox
            checked={checked}
            onChange={this._onChange}
            color="primary"
            value="skippable"
          />
          <Typography>
            {texts.section.allow_skip}
          </Typography>
        </div>
      </Section>
    );
  }
}

export default compose(
  withStyles(styles, { name: 'SkipSurvey' }),
  connect(
    state => {
      const selectedOrganization = get(state, 'auth.selectedOrganization');
      const organizations = get(state, 'auth.data.user.organizations') || [];
      return {
        selectedOrganization,
        organization: organizations.find(o => o._id === selectedOrganization),
        locale: state.appState.locale
      };
    },
    dispatch => ({
      updateSurveySkippable: params => dispatch(updateSurveySkippable(params)()),
      fetchUser: params => dispatch(fetchUser(params)()),
    }))
)(SkipSurvey);



// WEBPACK FOOTER //
// ./src/modules/organization/cards/SkipSurvey/index.js